import { map } from 'd3-collection';

const lookup = map();

const buildURL = path => `${process.env.PUBLIC_PATH}${path}`;

// u.s. senate
lookup.set(
  'e42bd313-71d5-48cd-aa82-987bf4d1cefc',
  buildURL('assets/images/cruz.png')
);
lookup.set(
  'c678e650-d40d-4c1e-a524-2d3b7e46b969',
  buildURL('assets/images/neal.png')
);
lookup.set(
  'f1c5a5fb-5939-4b9d-a4f4-1e0e2532dc72',
  buildURL('assets/images/beto.png')
);

// gov
lookup.set(
  '218079b8-1a49-41a1-bb9c-2317af3820e0',
  buildURL('assets/images/abbott.png')
);
lookup.set(
  '9ebbbabf-3f9a-49ad-b971-9b0e09601ace',
  buildURL('assets/images/tippetts.png')
);
lookup.set(
  '43fd87b5-c081-49e9-99de-17deeac0debf',
  buildURL('assets/images/valdez.png')
);

// lt. gov
lookup.set(
  '97119c40-bcd5-4832-b6b3-e0f718bf0fac',
  buildURL('assets/images/collier.png')
);
lookup.set(
  '77779e9f-c04b-4fd9-8ac2-435701c48048',
  buildURL('assets/images/mckennon.png')
);
lookup.set(
  '9e104fe7-12ec-4d61-a6bd-315a9ab4231c',
  buildURL('assets/images/patrick.png')
);

// land
lookup.set(
  '0b4bd374-ae21-4060-9c91-8257882649eb',
  buildURL('assets/images/bush.png')
);
lookup.set(
  'faa4dfc7-2a01-49e1-bb15-e085a7a9b48b',
  buildURL('assets/images/pina.png')
);
lookup.set(
  'f1cab0bd-e1af-4f34-9362-334dcedcff9e',
  buildURL('assets/images/suazo.png')
);

// ag comm
lookup.set(
  '4123bcf8-ebd1-49e8-9c82-2b2ae28161e7',
  buildURL('assets/images/carpenter.png')
);
lookup.set(
  '3130ea69-d457-46ac-96a9-22c96384576b',
  buildURL('assets/images/miller.png')
);
lookup.set(
  '8c13a73f-29a0-490c-8960-b87d5a20c52c',
  buildURL('assets/images/olson.png')
);

// ag
lookup.set(
  'bc589ec9-0bac-47d0-9086-67268ba1193a',
  buildURL('assets/images/harris.png')
);
lookup.set(
  '0e82e4aa-a51f-4880-94c1-0045e4e79658',
  buildURL('assets/images/nelson.png')
);
lookup.set(
  'b604a27f-1750-4e98-8c9d-65b04a444689',
  buildURL('assets/images/paxton.png')
);

// comp
lookup.set(
  '9a22cc92-73d8-4db6-8254-0e07b35bd988',
  buildURL('assets/images/chevalier.png')
);
lookup.set(
  'cf004360-6555-47e3-8787-cb3e4ae86aa1',
  buildURL('assets/images/hegar.png')
);
lookup.set(
  '53e71e5c-39a2-4b1b-adca-50e4237b9d5d',
  buildURL('assets/images/sanders.png')
);

// rr
lookup.set(
  'fd723090-c339-4e45-93ee-465adc23b5a7',
  buildURL('assets/images/craddick.png')
);
lookup.set(
  'acc223b7-ad7f-47d5-8289-b7c6976678aa',
  buildURL('assets/images/mcallen.png')
);
lookup.set(
  '53022a32-1bba-47c7-a30c-9e04e19db504',
  buildURL('assets/images/wright.png')
);

export { lookup };
